/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import * as React from "react";
import styled from "styled-components";
import { ThemePalette } from "@src/components/Theme";
import TopBar from "@src/components/modules/TemplateModule/TopBar";

/*
 * The Swift page frame, as in the Tech9IQ Ops Console (.t9-app): the sidebar on the left; on the
 * right the 56 px top bar and the pale workspace (var(--t9-bg-muted)) holding the page header and content.
 */
const Wrapper = styled.div`
  display: flex;
  height: 100%;
  min-height: 0;
  background: ${ThemePalette.grayscale[7]};
`;
const Navigation = styled.div`
  display: flex;
  flex-shrink: 0;
`;
const Main = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  padding: 0 24px 24px 24px;

  @media (max-width: 720px) {
    padding: 0 16px 16px 16px;
  }
`;
const Inner = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
`;
const List = styled.div<{ noMargin?: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
const Header = styled.div``;

type Props = {
  navigationComponent: React.ReactNode;
  headerComponent: React.ReactNode;
  listComponent: React.ReactNode;
  listNoMargin?: boolean;
};
const MainTemplate = (props: Props) => (
  <Wrapper>
    <Navigation>{props.navigationComponent}</Navigation>
    <Main>
      <TopBar />
      <Content>
        <Inner>
          <Header>{props.headerComponent}</Header>
          <List noMargin={props.listNoMargin}>{props.listComponent}</List>
        </Inner>
      </Content>
    </Main>
  </Wrapper>
);

export default MainTemplate;
